import { motion } from "framer-motion";
export default function CoralCard({
  children,
  className = "",
  delay = 0,
}) {
  return (
    <motion.div
      className={`rounded-2xl item-border border-[#FD5B38]/20 bg-gradient-coral p-6 md:p-8 ${className}`}
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{
        duration: 0.5,
        delay,
        ease: "easeOut",
      }}
    >
      {children}
    </motion.div>
  );
}
